import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication/authentication.service';

@Component({
    selector: 'user-details',
    template: require('./user-details.component.html')
})
export class UserDetailsComponent {

	constructor(private auth: AuthenticationService, private router: Router) {
		console.dir(auth.decodedAccessToken);
		this.token = auth.decodedAccessToken;
    }

    token;

	logoff(): void {
		this.auth.logOut();
		this.router.navigateByUrl('/');
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shell/user-details.component.ts